import React, { useEffect, useState } from 'react';
import { X, Undo2 } from 'lucide-react';
import { useToast } from '../../context/ToastContext';

const Toast = ({ toast }) => {
  const { removeToast } = useToast();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger enter animation
    const timer = setTimeout(() => setIsVisible(true), 50);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => removeToast(toast.id), 300); // Wait for exit animation
  };

  const handleUndo = () => {
    if (toast.onUndo) {
      toast.onUndo();
    }
    handleClose();
  };

  const getToastStyles = () => {
    const baseStyles = "flex items-center justify-between p-4 rounded-lg shadow-lg border max-w-md";
    const visibilityStyles = isVisible 
      ? "transform translate-y-0 opacity-100" 
      : "transform translate-y-2 opacity-0";
    
    switch (toast.type) {
      case 'undo':
        return `${baseStyles} bg-gray-800 dark:bg-gray-700 text-white border-gray-700 dark:border-gray-600 ${visibilityStyles}`;
      case 'success':
        return `${baseStyles} bg-green-50 dark:bg-green-900 text-green-800 dark:text-green-200 border-green-200 dark:border-green-700 ${visibilityStyles}`;
      case 'error':
        return `${baseStyles} bg-red-50 dark:bg-red-900 text-red-800 dark:text-red-200 border-red-200 dark:border-red-700 ${visibilityStyles}`;
      default:
        return `${baseStyles} bg-blue-50 dark:bg-blue-900 text-blue-800 dark:text-blue-200 border-blue-200 dark:border-blue-700 ${visibilityStyles}`;
    }
  };

  return (
    <div className={`transition-all duration-300 ease-out ${getToastStyles()}`}>
      <div className="flex items-center gap-3">
        <span className="text-sm font-medium">{toast.message}</span>
        {toast.type === 'undo' && (
          <button
            onClick={handleUndo}
            className="flex items-center gap-1 px-2 py-1 text-xs font-medium bg-white/20 hover:bg-white/30 rounded transition-colors"
          >
            <Undo2 size={12} />
            Undo
          </button>
        )}
      </div>
      <button
        onClick={handleClose}
        className="ml-3 text-current opacity-70 hover:opacity-100 transition-opacity"
      >
        <X size={16} />
      </button>
    </div>
  );
};

const ToastContainer = () => {
  const { toasts } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 space-y-2">
      {toasts.map(toast => (
        <Toast key={toast.id} toast={toast} />
      ))}
    </div>
  );
};

export default ToastContainer;